var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6335",
    "data-name": "Rectangle 6335",
    width: 41.555,
    height: 36.701,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34954",
    "data-name": "Group 34954",
    transform: "translate(-5225 -5406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(5225 5406)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34885",
    "data-name": "Group 34885",
    transform: "translate(5241 5425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34884",
    "data-name": "Group 34884",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24415",
    "data-name": "Path 24415",
    d: "M0,14.694a2.238,2.238,0,0,1,1.859-1.752,5.252,5.252,0,0,1,1.093-.023c.277.015.39-.075.48-.343a18.189,18.189,0,0,1,3.881-6.63,1.863,1.863,0,0,1,.259-.257.6.6,0,0,1,.881.775,1.748,1.748,0,0,1-.255.313A17.237,17.237,0,0,0,4.739,12.5c-.045.123-.08.25-.132.412,1.317,0,2.587.009,3.857-.013.119,0,.284-.17.346-.3a13.245,13.245,0,0,1,23.873-.086.611.611,0,0,0,.667.409c1.175-.025,2.352-.01,3.59-.01-.054-.167-.088-.3-.14-.432C34.224,6.081,29.564,2.26,22.7,1.345A16.258,16.258,0,0,0,11.36,4.064c-.1.066-.2.14-.306.2A.6.6,0,0,1,10.23,4.1a.585.585,0,0,1,.178-.85,27.25,27.25,0,0,1,2.446-1.431A18.233,18.233,0,0,1,38.085,12.5c.109.323.249.442.591.423a4.754,4.754,0,0,1,1.169.06,2.089,2.089,0,0,1,1.7,2.047q.023,3.306,0,6.613a2.15,2.15,0,0,1-2.115,2.135c-.39.013-.782,0-1.116,0-.457,1.042-.828,2.077-1.345,3.034a17.882,17.882,0,0,1-13.037,9.6A18.217,18.217,0,0,1,3.478,24.229c-.119-.358-.273-.495-.648-.457a3.86,3.86,0,0,1-.971-.022A2.247,2.247,0,0,1,0,22Zm31.482,9.084c-.407,0-.773.013-1.137,0a.551.551,0,0,1-.572-.6.568.568,0,0,1,.569-.607c.121-.009.244,0,.365,0q4.24,0,8.48,0c.783,0,1.143-.358,1.144-1.137q0-3.063,0-6.127c0-.814-.348-1.169-1.152-1.169H2.378c-.811,0-1.16.35-1.16,1.161q0,2.981,0,5.964c0,1.011.294,1.308,1.3,1.308H26.171c.135,0,.271-.008.406,0a.54.54,0,0,1,.533.593c0,.427-.248.619-.809.619H10.07A11.877,11.877,0,0,0,20.6,30.438a12,12,0,0,0,10.877-6.66m5.433,0c-1.226,0-2.416.014-3.6-.009a.587.587,0,0,0-.627.407,13.243,13.243,0,0,1-23.858-.054c-.066-.136-.215-.328-.329-.33-1.281-.023-2.562-.014-3.853-.014a16.98,16.98,0,0,0,32.271,0M31.484,12.9a11.912,11.912,0,0,0-12.168-6.56A11.748,11.748,0,0,0,12.509,9.56,11.283,11.283,0,0,0,10.038,12.9Z",
    transform: "translate(0 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24416",
    "data-name": "Path 24416",
    d: "M23.355,18.736c.177-.576.362-1.149.528-1.729.1-.338.235-.612.635-.621.428-.008.566.29.667.636a13.683,13.683,0,0,0,.6,1.72q.148-.747.3-1.493c.024-.119.044-.239.076-.357a.6.6,0,1,1,1.178.26c-.209,1.1-.425,2.2-.638,3.3-.046.239-.085.48-.139.716a.7.7,0,0,1-1.37.073c-.188-.6-.37-1.213-.557-1.818-.022-.072-.058-.139-.117-.278-.219.713-.423,1.351-.609,1.993a.707.707,0,0,1-.744.608c-.426-.013-.6-.281-.677-.672-.246-1.3-.507-2.6-.758-3.9a.591.591,0,0,1,.447-.778.6.6,0,0,1,.748.545c.122.595.235,1.191.352,1.787l.085,0",
    transform: "translate(-0.845 -0.638)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24417",
    "data-name": "Path 24417",
    d: "M17.061,19.038c0-.648,0-1.3,0-1.944,0-.5.217-.713.714-.721.364-.006.729-.008,1.094,0a1.533,1.533,0,0,1,1.448,2.06.49.49,0,0,0,.1.534,1.724,1.724,0,0,1-1.34,2.785c-.432.007-.865.009-1.3,0a.644.644,0,0,1-.716-.731c-.007-.662,0-1.323,0-1.986M18.3,20.528a3.271,3.271,0,0,0,.843-.018.662.662,0,0,0,.4-.418.557.557,0,0,0-.227-.49,5.231,5.231,0,0,0-1.015-.1Zm0-3.02v.831a6.105,6.105,0,0,0,.813-.207c.052-.02.068-.337.03-.355a7.616,7.616,0,0,0-.843-.27",
    transform: "translate(-0.664 -0.638)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24418",
    "data-name": "Path 24418",
    d: "M11.451,18.508c0-.5-.011-1,0-1.5a.553.553,0,0,1,.6-.617.569.569,0,0,1,.606.618c.016.878,0,1.758.01,2.636,0,.613.249.883.8.889.565.006.837-.28.84-.9,0-.838,0-1.676,0-2.515,0-.5.208-.746.6-.746s.611.259.614.743c.007.893.012,1.785,0,2.678a1.784,1.784,0,0,1-1.338,1.814,2.128,2.128,0,0,1-2.377-.667,2.141,2.141,0,0,1-.329-.935,13.922,13.922,0,0,1-.013-1.5h-.01",
    transform: "translate(-0.446 -0.638)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24419",
    "data-name": "Path 24419",
    d: "M32.654,21.273c-.122.12-.261.361-.451.411s-.434-.086-.654-.148a.138.138,0,0,1-.064-.1c-.1-.765-.649-.707-1.219-.709-.464,0-.78.051-.91.579a.539.539,0,0,1-.749.408.587.587,0,0,1-.38-.812c.5-1.367,1.012-2.728,1.527-4.088a.569.569,0,0,1,.657-.421.956.956,0,0,1,.618.411c.546,1.363,1.04,2.746,1.549,4.123a3.447,3.447,0,0,1,.074.345m-2.6-1.79h.7l-.349-.923c-.137.366-.235.625-.347.923",
    transform: "translate(-1.097 -0.638)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24420",
    "data-name": "Path 24420",
    d: "M8.275,21.757a2.458,2.458,0,0,1-1.716-.706c-.316-.307-.348-.618-.1-.889s.572-.242.934-.016a2.974,2.974,0,0,0,1.027.37.53.53,0,0,0,.442-.289c.029-.14-.127-.364-.262-.481a2.016,2.016,0,0,0-.548-.254c-.186-.079-.376-.149-.561-.229-.755-.329-1.024-.737-.936-1.416a1.643,1.643,0,0,1,1.37-1.454,2.412,2.412,0,0,1,1.829.495.6.6,0,0,1,.176.853.627.627,0,0,1-.861.154,3.205,3.205,0,0,0-.9-.281c-.123-.017-.273.165-.41.257.1.1.183.241.3.3.3.151.623.259.93.4a1.643,1.643,0,0,1-.712,3.189",
    transform: "translate(-0.245 -0.638)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24421",
    "data-name": "Path 24421",
    d: "M34.879,17.881c.275-.429.5-.8.742-1.154a.6.6,0,0,1,.864-.261.617.617,0,0,1,.156.919c-.319.517-.663,1.02-.972,1.543a1.373,1.373,0,0,0-.179.6c-.027.526,0,1.054-.018,1.581-.012.418-.212.627-.578.638-.381.012-.6-.209-.632-.633a.707.707,0,0,1,0-.162,4,4,0,0,0-1-3.323,1.943,1.943,0,0,1-.215-.343.6.6,0,0,1,1.024-.635c.268.384.513.784.8,1.232",
    transform: "translate(-1.283 -0.638)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroStation);
export default __webpack_public_path__ + "static/media/metroStation.97fd5169d17a00189f027836f7d13db8.svg";
export { ForwardRef as ReactComponent };